<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Login User</div>
        <div>
          <bread-crumb :bread-crumbs="['Login User']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text>
        <v-row class="mt-1">
          <v-col cols="12" md="2" lg="2" xs="12">
            <v-text-field
              placeholder="User Type"
              :items="loginUser"
              v-model="user_type"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <div class="d-flex">
            <v-btn depressed 
              small
              class="text-capitalize"
              @click="getLoginuserdata()"
              color="primary"
              >Get Results</v-btn
            >
          </div>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4" lg="4" xs="12"
            ><v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to search the table data."
              hide-details
              class="me-4"
              dense
              single-line
              clearable
            ></v-text-field
          ></v-col>
        </v-row>
        <v-data-table fixed-header  height="55vh"
          :headers="headers"
          :items="loginUser"
          :items-per-page="10"
          dense
          loading-text="Please select the criteria to view records."
          no-data-text="Please select the criteria to view records."
          class="mt-6"
        >
          <!-- <template v-slot:item.actions="{ item }">
            <v-icon small color="primary" class="mr-2" @click="editItem(item)">
              mdi-eye-outline
            </v-icon>
          </template> -->
        </v-data-table>
      </v-card-text>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import userService from "@/services/UserService/userService.js";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name: "Login User",
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  data: () => ({
    headers: [
      { text: "Log Type", value: "log_type" },
      { text: "IP", value: "ip" },
      { text: "Reason", value: "reason" },
      { text: "User", value: "user" },
      { text: "Log Date", value: "log_date" },
      { text: "", value: "view_icon", align: "center" },
    ],
    loginUser: [],
    loaderOverlay: false,
    search: "",
    user_type: "",
  }),
  mounted() {},
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async getLoginuserdata() {
      this.loaderOverlay = true;
      try {
        const params = {
          user_type: this.user_type,
          skip: 0,
          limit: 50,
        };
        const response = await userService.getLoginlog(params);
        if (response.status === 200) {
          this.loginUser = response.data;
          console.log("loginUser", this.loginUser);
          this.stoploader();
        } else if (response.status === 401) {
          this.loginUser = [];
          // this.returnNewToken();
          // this.getUseraduitlogdata();
          // this.stoploader();
        } else {
          this.loginUser == [];
          this.stoploader();
        }
      } catch (error) {
        this.loginUser = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
</style>
